import { useTranslation } from "react-i18next";
import { Spinner } from "../../atoms/Spinner";

export const TableEndContent = () => {
  const { t } = useTranslation();

  return (
    <div data-slot="table-end" className="flex items-center justify-center py-3">
      <Spinner size="xs" color="muted" direction="row">
        {t("Loading more...")}
      </Spinner>
    </div>
  );
};
